/**
 * Creates a log message.
 * @private
 * @export
 * @param {string} [message=''] 
 * @returns {string} 
 */
export function log(message:string = ''): string {
  return `lodash-decorators -> ${message}`;
}
